import { NavigateFunction } from 'react-router-dom';
import { isReactClientRoute } from './navigation';
import { navigateToStaffRoute } from './nativeNavigation';
import {
  CUSTOMER_HOME_PATH,
  isCustomerDefaultPath,
  isPartnerRole,
  isPartnersHost,
} from './hostNavigation';

function pathnameOf(path: string): string {
  const raw = (path || '').trim();
  if (/^https?:\/\//i.test(raw)) {
    try {
      return new URL(raw).pathname || '/';
    } catch {
      return '/';
    }
  }
  return raw.split('?')[0].split('#')[0] || '/';
}

/** Guest-app destinations allowed after login on www.peppar.in. */
export function isCustomerPortalRedirect(path: string): boolean {
  const raw = (path || '').trim();
  if (!raw) {
    return false;
  }
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      if (isPartnersHost(url.hostname)) {
        return false;
      }
    } catch {
      return false;
    }
  }
  const pathname = pathnameOf(raw);
  return (
    pathname.startsWith('/restaurants') ||
    pathname === '/my-account' ||
    pathname.startsWith('/my-account/') ||
    pathname === '/saved-addresses' ||
    pathname.startsWith('/saved-addresses/') ||
    pathname === '/my-orders' ||
    pathname.startsWith('/my-orders/')
  );
}

export async function navigateAfterAuth(
  redirectUrl: string,
  options: {
    urlRedirect?: string | null;
    isPartners?: boolean;
    navigate: NavigateFunction;
    roleId?: number | null;
  }
): Promise<void> {
  const urlRedirect = options.urlRedirect;
  const onPartnersHost = options.isPartners ?? isPartnersHost();
  let target = urlRedirect ? decodeURIComponent(urlRedirect) : redirectUrl || '/';

  if (!onPartnersHost) {
    if (!urlRedirect || !isCustomerPortalRedirect(target)) {
      target = CUSTOMER_HOME_PATH;
    }
    if (/^https?:\/\//i.test(target)) {
      window.location.assign(target);
      return;
    }
    if (isReactClientRoute(target)) {
      options.navigate(target, { replace: true });
      return;
    }
    options.navigate(CUSTOMER_HOME_PATH, { replace: true });
    return;
  }

  if (!urlRedirect && isPartnerRole(options.roleId) && isCustomerDefaultPath(target)) {
    target = '/partner/setup';
  }

  if (/^https?:\/\//i.test(target)) {
    window.location.assign(target);
    return;
  }

  if (isReactClientRoute(target)) {
    options.navigate(target, { replace: true });
    return;
  }
  await navigateToStaffRoute(target);
}
